import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  headerWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: `1px solid #E2E2EA`,
    padding: "14px",
    position: "fixed",
    right:0, top: 0,
    background: "#fff",
    width: "70vw",
    maxWidth: "1281px",
    zIndex: 999,
  },
  backAndNavigationWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    zIndex: 2
  },
  backNavigation: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  navigationWrapper: {
    display: "flex",
    flexDirection: "row",
  },
  navigationLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    height: "32px",
    width: "46px",
    backgroundColor: "#F2F3F7",
    borderRadius: "10px 0 0 10px"
  },
  navigationRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    height: "32px",
    width: "46px",
    border: "1px solid #E2E2EA",
    borderRadius: " 0 10px 10px 0"
  },
  indexNavigation: {
    color: "#7E7E8F",
    fontSize: "12px",
    marginRight: "12px",
  },
  actionsWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "24px"
  },
  actionsButtons: {
    display: "flex",
    gap: "24px"
  },
  openFullPage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    height: "34px",
    width: "34px",
    border: "1px solid #7E7E8F",
    borderRadius: "12px"
  },
  copyPath: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    height: "34px",
    width: "34px",
    border: "1px solid #7E7E8F",
    borderRadius: "12px",
    "&:hover": {
      backgroundColor: "#E5E5E5",
    }
  },
  verticalDivider: {
    width: "1px",
    height: "43px",
    borderLeft: "1px solid #E2E2EA"
  },
  informationsTitleWrapper: {
    paddingLeft: "16px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  informationsEtablissement: {
    backgroundColor: theme.palette.primary.primary100,
    fontSize: "16px",
    fontWeight: "600",
    padding: "9px",
    borderRadius: "8px",
    display: 'flex',
    alignItems: 'center'
  },
}));

export default useStyles;
